import React, { useState } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Do you provide the lights or do we buy our own?",
      answer: "We supply and install commercial-grade LED Christmas lights designed for outdoor use. They are brighter, safer, and longer-lasting than store-bought lights."
    },
    {
      question: "What happens after the holidays?",
      answer: "We take everything down and can store your lights for next season. This ensures your investment is protected and ready for the following year."
    },
    {
      question: "Do you install lights on commercial buildings?",
      answer: "Yes, we specialize in plaza, office, and storefront holiday lighting across Barrie, Collingwood, Orillia, and nearby towns."
    },
    {
      question: "Are you insured for working at heights?",
      answer: "Absolutely! We are fully insured and our team is trained for safe working-at-heights installations."
    },
    {
      question: "How early should I book my Christmas light installation?",
      answer: "We recommend booking by early November to ensure availability. Peak season fills up quickly, especially for commercial properties."
    },
    {
      question: "What areas do you service?",
      answer: "We proudly serve Barrie, Collingwood, Orillia, Innisfil, Wasaga Beach, Midland, and surrounding Simcoe County communities."
    }
  ];

  return (
    <section className="py-8 bg-white">
      <div className="container mx-auto px-6">
        <h2 className="dest_heading mb-12">Frequently Asked Questions</h2>
        <div className="max-w-4xl mx-auto">
          {faqs.map((faq, index) => (
            <div key={index} className="mb-4 border border-gray-200 rounded-lg overflow-hidden">
              <button
                className="w-full text-left p-6 bg-gray-50 hover:bg-gray-100 transition-colors duration-200 flex justify-between items-center"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="font-semibold text-gray-800">{faq.question}</span>
                <span className="text-2xl text-red-600">
                  {openIndex === index ? '−' : '+'}
                </span>
              </button>
              {openIndex === index && (
                <div className="p-6 bg-white border-t border-gray-200">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;